import * as React from 'react';
import classNames from 'classnames';
import { NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import styles from './BaseHeading.module.esm.js';

var BaseHeading = function (_a) {
    var heading = _a.heading, _b = _a.headingAlignment, headingAlignment = _b === void 0 ? 'center' : _b, headingClasses = _a.headingClasses, body = _a.body, bodyClasses = _a.bodyClasses, className = _a.className, subheading = _a.subheading, subheadingClasses = _a.subheadingClasses;
    return (React.createElement("header", { className: classNames('nv-container', styles[headingAlignment], styles.baseHeading, className) },
        React.createElement(NvMarkdownInline, { className: headingClasses, element: "h2", elementWrapper: NvHeading, level: 2 }, heading),
        subheading && (React.createElement(NvMarkdownInline, { className: classNames('nv-subheading-1', styles.subheading, subheadingClasses), elementWrapper: "h3" }, subheading)),
        body && React.createElement(NvMarkdown, { className: classNames('nv-subheading-1', styles.body, bodyClasses) }, body)));
};

export { BaseHeading as default };
//# sourceMappingURL=BaseHeading.esm.js.map
